<template>
    <dd class="selectRoom fix" >
        <i class="check_box stateroom_check" :class="{ cur: isSelected}" @click="onStateroomSelected(shoppingCarts)"></i>
        <div class="f-fl img_box">
            <img :class="{'qiaohuStateroomBackground': isQiaohu, 'starrySkyStateroomBackground': isStarrySky, 'customThemeStateroomBackground':
            isCustomTheme}"
                :src="stateroomImage" alt="">
        </div>
        <div class="f-fl tool_box">
            <a class="tool_btn delete_btn" @click="onDeleteByStateroom(shoppingCarts)"><i class="detail_ico_18 delete_ico"></i>删除</a>
            <div class="detail_add_btn shoppingCartDeleteBtn">
                <span class="less disabled" @click="deleteShoppingCart(shoppingCart)"></span>
                <div class="stateroomcount">{{count}}</div>
                <span class="add " @click="onAddShoppingCart(shoppingCart)"></span>
            </div>
        </div>
        <div class="f-fl info_box">
            <img class="QIAOHU_CSS qiaohu_tag" @click="showQiaohuPopup(shoppingCart.shipCode, shoppingCart.sailDate)"
                v-if="isQiaohu" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png">
            <img class="QIAOHU_CSS qiaohu_tag" @click="showStarrySkyPopup(shoppingCart.shipCode, shoppingCart.sailDate)"
                v-if="isStarrySky" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png">
            <img class="CUSTOM_THEME_CSS qiaohu_tag" @click="showCustomThemePopup(shoppingCart.stateroomPartRecord.personalizedStateroomInfo)"
               v-if="isCustomTheme" :src="shoppingCart.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage" />
            <div class="info_title">
                <span class="cabinName">{{stateroomName}}</span>
                <NrpTag
                    :isNrp="shoppingCart.isnrp"
                    :isFortyEightHoursNrpCruise="shoppingCart.isFortyEightHoursNrpCruise"
                    :direction="'left'"
                    :targetContainer="'app'"
                    :customClasses="['shoppingCartStateroomNrp']"
                    :showRow="showRow"
                />
            </div>
            <div class="info_tags">舱房: {{stateroom.areaInfo}}&nbsp;&nbsp;|&nbsp;&nbsp;{{stateroomBalcony}}</div>
            <div class="info_price" v-if="shoppingCart.netAmount > 0">{{getPriceType(shoppingCart)}}(含税): <span><em>￥</em>
                <span class="stateroomPrice">{{shoppingCart.netAmount > 0 ? shoppingCart.netAmount.toFixed(0): ''}}</span></span>/人起
            </div>
            <!-- <div class="info_price original_price" v-if="shoppingCart.netAmount > 0">零售指导价(含税): ￥{{shoppingCart.originAmount > 0 ? shoppingCart.originAmount.toFixed(0): ''}}/人起</div> -->
            <!-- <div class="soldOutText" v-if="!shoppingCart.netAmount || shoppingCart.netAmount <= 0">售罄</div> -->
        </div>
    </dd>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
const NrpTag = () => import('@/components/Booking/NrpTag')
export default {
    name: "ShoppingCartStateroom",
    components: {
        NrpTag
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onStateroomSelected: {
            type: Function
        },
        onAddShoppingCart: {
            type: Function
        },
        onDeleteShoppingCart: {
            type: Function
        },
        onDeleteByStateroom: {
            type: Function
        },
        showQiaohuPopup: {
            type: Function
        },
        showStarrySkyPopup: {
            type: Function
        },
        showCustomThemePopup: {
          type: Function
        },
        showRow: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        deleteShoppingCart (shoppingCart) {
            if (this.count == 1) {
                this.$alert.show('受不了了，舱房不能再减少了哦！')
                return
            }
            this.onDeleteShoppingCart(shoppingCart)
        },
        getPriceType (shoppingCart) {
            if (shoppingCart.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.priceType
            }
            return shoppingCart.isnrp ? nrpConfig.nrp.priceType: nrpConfig.rp.priceType
        },
        getNrpTitle (shoppingCart) {
            if (shoppingCart.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            }
            return shoppingCart.isnrp ? nrpConfig.nrp.title: nrpConfig.rp.title
        }
    },
    computed: {
        shoppingCart () {
            if (!this.shoppingCarts || this.shoppingCarts.length == 0) {
                return {}
            }
            return this.shoppingCarts[this.shoppingCarts.length - 1]
        },
        count () {
            return this.shoppingCarts.length
        },
        isSelected () {
            const shoppingCart = this.shoppingCart
            return this.selectedShoppingCarts
            .some(r=>r.berthedCategoryCode == shoppingCart.berthedCategoryCode
                && r.isnrp == shoppingCart.isnrp
                && r.groupType == shoppingCart.groupType)
        },
        isQiaohu () {
            const shoppingCart = this.shoppingCart
            return shoppingCart.groupType == 'QIAOHU'
        },
        isStarrySky () {
          const shoppingCart = this.shoppingCart
          return shoppingCart.groupType == 'STARRYSKY'
        },
        isCustomTheme () {
          const shoppingCart = this.shoppingCart
          return shoppingCart.groupType == 'CUSTOM' || shoppingCart.groupType == 'PCPGIFT'
        },
        stateroom () {
            const shoppingCart = this.shoppingCart
            if (!shoppingCart.stateroomPartRecord) {
                return {}
            }
            return shoppingCart.stateroomPartRecord
        },
        stateroomName () {
            if (!this.stateroom.stateroomCategoryCode) return ''
            let name = this.stateroom.cnName
            let code = this.stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return `${name}_${code}`
        },
        stateroomBalcony () {
            const balcony = this.stateroom.balconyAreaInfo
            if (!balcony || balcony == '' || balcony == '无') {
                return '无阳台'
            }
            return balcony
        },
        stateroomImage () {
            if (this.shoppingCart.stateroomImages && this.shoppingCart.stateroomImages.length > 0) {
                return this.shoppingCart.stateroomImages[0]
            }
            return ''
        }
    }
}
</script>

<style lang="less" scoped>
dd {
    position: relative;
    margin-bottom: 16px;
    .check_box {
        position: absolute;
        top: 0;
        left: -25px;
        width: 18px;
        height: 18px;
        border: 1px solid #d3dadd;
        border-radius: 2px;
    }
    .check_box.cur {
        background: url(https://resource.rcclchina.com.cn/tui2/list/icon-checkBox-checked.png) no-repeat center;
        border-color: #006ab9;
    }
    .img_box {
        position: relative;
        width: 55%;
        margin-right: 5%;
        img {
            width: 100%;
            height: 85px;
        }
        .qiaohuStateroomBackground {
            border: 3px solid #ffe100;
        }
        .starrySkyStateroomBackground {
          border: 3px solid #ffe100;
        }
        .customThemeStateroomBackground {
          border: 3px solid #ffe100;
        }
    }
    .tool_box {
        width: 40%;
        .delete_btn {
            margin-bottom: 30px;
            display: block;
            cursor: pointer;
            font-weight: 400;
            color: #747d80;
            .detail_ico_18.delete_ico {
                background: url(https://resource.rcclchina.com.cn/tui2/list/trash.png) no-repeat;
            }
        }
        .shoppingCartDeleteBtn {
            position: absolute;
            right: 22px;
            top: 64px;
             span {
                position: relative;
                width: 20px;
                height: 20px;
                border: 1px solid #d3dadd;
                background: #fff;
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
            }
            span.disabled {
                background-color: #F1F4F7;
            }
            span:before,span:after {
                content: '';
                display: block;
                position: absolute;
                background: #016bb9;
            }
            span:after {
                width: 10px;
                margin-left: -5px;
                top: 8px;
                height: 2px;
                left: 50%;
            }
            .disabled:before,.disabled:after {
                background: #a6aeb1;
            }
            .stateroomcount {
                display: inline-block;
                padding-left: 10px;
            }
            span.add {
                margin-left: 10px;
            }
            .add:before {
                height: 10px;
                margin-top: -9px;
                margin-left: -1px;
                width: 2px;
                left: 50%;
                top: 13px;
            }
        }
    }
    .info_box {
        .QIAOHU_CSS {
            width: 117px;
            height: 31px;
            margin-top: 5px;
        }
        .CUSTOM_THEME_CSS {
          height: 30px;
          margin: 7px 0 2px;
        }
        .info_title {
            font-weight: bold;
            padding: 5px 0px;
        }
        .info_price {
            padding-top: 0px;
            span {
                font-size: 16px;
                color: #ff3022;
                em {
                    font-style: normal;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
